import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseButtonSvg from 'src/public/img/icon-close-circle-lg.svg';
import { IntakeFormTestID } from '../models/intakeForm';

interface Props {
    onClick: () => void;
}

const ButtonWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 24,
    width: '100%',
});

export const AbandonButton: React.FC<Props> = ({ onClick }) => {
    const { t } = useTranslation();
    const handleClick = evt => {
        evt.preventDefault();

        onClick();
    };

    return (
        <ButtonWrapper>
            <form onSubmit={handleClick} data-testid={IntakeFormTestID.AbandonButton}>
                <input
                    type="image"
                    src={CloseButtonSvg}
                    alt={t('intakeForms:abandon_button.close')}
                />
            </form>
        </ButtonWrapper>
    );
};
